import React from 'react';
import { CgArrowLongDown, CgArrowLongUp } from 'react-icons/cg';

import './SorterButton.scss';

function SorterButton({ activeSorter, type, label, changeSorter }) {
  function getSorterIcon() {
    return activeSorter.direction == 'asc' ? (
      <CgArrowLongUp />
    ) : (
      <CgArrowLongDown />
    );
  }

  return (
    <a
      key={`sorter_${label}`}
      className={`sort_button ${activeSorter.type == type && 'active'}`}
      onClick={() => changeSorter(type)}
    >
      {' '}
      {activeSorter.type == type && 'active' && getSorterIcon()}
      {label}
    </a>
  );
}

export default SorterButton;
